module.exports = __webpack_public_path__ + "img/what-app-icon.8e72dd73.png";